import { HttpErrorResponse } from '@angular/common/http';
import {
  CreateHostedPaymentsSessionRequest,
  CreateHostedPaymentsSessionResponse,
} from '@arc/unified-payments-frontend/shared-payment';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const HostedPaymentsLandingComponentActions = createActionGroup({
  source: 'Hosted Payments Landing Component',
  events: {
    Initialize: props<{
      supplierName: string;
      request: CreateHostedPaymentsSessionRequest;
    }>(),

    'Create Hosted Payments Session Success': props<{
      response: CreateHostedPaymentsSessionResponse;
    }>(),

    'Create Hosted Payments Session Error': props<{
      error: HttpErrorResponse;
    }>(),

    'Verify User Is Provisioned Success': emptyProps(),

    'Verify User Is Provisioned Error': props<{ error: HttpErrorResponse }>(),
  },
});
